const Data=[
    {
        id:1,
        title:"Security Guard",
        para:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nostrum possimus, praesentium doloribus doloremque, sit pariatur eveniet ab iste ad voluptatibus architecto labore maxime, cupiditate assumenda?",
        image:"https://images.pexels.com/photos/8927193/pexels-photo-8927193.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load"
    },
    {
        id:2,
        title:"Night Guard",
        para:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nostrum possimus, praesentium doloribus doloremque, sit pariatur eveniet ab iste ad voluptatibus architecto labore maxime, cupiditate assumenda?",
        image:"https://images.pexels.com/photos/1119152/pexels-photo-1119152.jpeg?auto=compress&cs=tinysrgb&w=600"
    },

    {
        id:3,
        title:"Driver",
        para:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nostrum possimus, praesentium doloribus doloremque, sit pariatur eveniet ab iste ad voluptatibus architecto labore maxime, cupiditate assumenda?",
        image:"https://images.pexels.com/photos/4320787/pexels-photo-4320787.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load"
    },

    {
        id:4,
        title:"Personal Assistant",
        para:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nostrum possimus, praesentium doloribus doloremque, sit pariatur eveniet ab iste ad voluptatibus architecto labore maxime, cupiditate assumenda?",
        image:"https://images.pexels.com/photos/5668807/pexels-photo-5668807.jpeg?auto=compress&cs=tinysrgb&w=600"
    },

    {
        id:5,
        title:"Female Assistant",
        para:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nostrum possimus, praesentium doloribus doloremque, sit pariatur eveniet ab iste ad voluptatibus architecto labore maxime, cupiditate assumenda?",
        image:"https://images.pexels.com/photos/1205268/pexels-photo-1205268.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
    },


    {
        id:6,
        title:"Armed Guard",
        para:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nostrum possimus, praesentium doloribus doloremque, sit pariatur eveniet ab iste ad voluptatibus architecto labore maxime, cupiditate assumenda?",
        image:"https://images.pexels.com/photos/3706670/pexels-photo-3706670.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load"
    },
  
    {
        id:7,
        title:"Auxiliary Services",
        para:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nostrum possimus, praesentium doloribus doloremque, sit pariatur eveniet ab iste ad voluptatibus architecto labore maxime, cupiditate assumenda?",
        image:"https://images.pexels.com/photos/6379410/pexels-photo-6379410.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load"
    },
    {
        id:8,
        title:"Crisis Management",
        para:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nostrum possimus, praesentium doloribus doloremque, sit pariatur eveniet ab iste ad voluptatibus architecto labore maxime, cupiditate assumenda?",
        image:"https://images.pexels.com/photos/73869/honor-guard-15s-guard-russian-73869.jpeg?auto=compress&cs=tinysrgb&w=600"
    },
    {
        id:9,
        title:"Supervisor Services",
        para:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nostrum possimus, praesentium doloribus doloremque, sit pariatur eveniet ab iste ad voluptatibus architecto labore maxime, cupiditate assumenda?",
        image:"https://images.pexels.com/photos/6379410/pexels-photo-6379410.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load"
    },


   

]

export default Data;